import { type ComponentProps } from 'react'

import { headerLinks } from '@fe-toolkit/utility'
import { blackFridayHeaderLinks } from '@giffgaff/fe-design-system-content'

import type { Header as LegacyHeader } from '@fe-toolkit/web-components/ssr'

type LegacyHeaderTopLink = NonNullable<ComponentProps<typeof LegacyHeader>['links']>[number]

// The legacy Header keys links by `id`; this stays clear of the toolkit's ids, as in fe-common.
const LEGACY_BLACK_FRIDAY_ID = 1000

// Stops compiling if the packaged set no longer leads with its Black Friday entry.
const blackFriday: Extract<(typeof blackFridayHeaderLinks)[number], { entryId: 'black-friday' }> =
  blackFridayHeaderLinks[0]

const { title, url, analyticsId, loggedInOnly, loggedOutOnly } = blackFriday

const legacyBlackFridayHeaderLinks: LegacyHeaderTopLink[] = [
  { id: LEGACY_BLACK_FRIDAY_ID, title, url, analyticsId, loggedInOnly, loggedOutOnly, openByDefaultMobile: false },
  ...headerLinks,
]

/**
 * The legacy Header's navigation: the toolkit's `headerLinks`, with the packaged Black Friday link first while
 * Black Friday or its pre-registration is on, as fe-common's legacy Header shows it (ported from
 * fe-modern-template).
 */
export const getLegacyHeaderLinks = ({
  isBlackFriday,
  isBlackFridayPrereg,
}: {
  isBlackFriday: boolean
  isBlackFridayPrereg: boolean
}): LegacyHeaderTopLink[] => (isBlackFriday || isBlackFridayPrereg ? legacyBlackFridayHeaderLinks : headerLinks)
